import React, { useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faLinkedin, faGithub } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-svg-core/styles.css";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const form = useRef();

  const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
  const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
  const EMAILJS_USER_ID = process.env.REACT_APP_EMAILJS_USER_ID;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!EMAILJS_USER_ID) {
      console.error(
        "The user ID is required. Visit https://dashboard.emailjs.com/admin/integration",
      );
      setToastMessage("Error: EmailJS User ID is missing!");
      setShowToast(true);
      return;
    }

    emailjs
      .sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        form.current,
        EMAILJS_USER_ID,
      )
      .then(
        (result) => {
          setToastMessage("Email sent successfully!");
          setShowToast(true);
        },
        (error) => {
          console.error("EmailJS error:", error);
          setToastMessage("Error sending email!");
          setShowToast(true);
        },
      );
  };

  return (
    <div className="contact" style={{ padding: "10px" }}>
      <ToastContainer position="top-center">
        <Toast
          bg="success"
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={3000}
          autohide
        >
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>
      <Container className="my-5">
        <Row>
          <Col md={6}>
            <p>
              <FontAwesomeIcon icon={faEnvelope} /> Email:
              amalinazafirahhashim@gmail.com
            </p>
            <p>
              <FontAwesomeIcon icon={faLinkedin} /> LinkedIn:{" "}
              <a href="https://sg.linkedin.com/in/amalina-hashim-75644bb7">
                amalina-hashim
              </a>
            </p>
            <p>
              <FontAwesomeIcon icon={faGithub} /> Github:{" "}
              <a href="https://github.com/Amalina-Hashim">Amalina-Hashim</a>
            </p>
          </Col>
          <Col md={6}>
            <Form ref={form} onSubmit={handleSubmit} data-clarity-mask="true">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Your Email</Form.Label>
                <Form.Control
                  type="text"
                  name="from_name"
                  placeholder="Enter your email"
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicMessage">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  placeholder="Enter your message"
                  rows={3}
                  required
                />
              </Form.Group>

              <Button
                variant="primary"
                type="submit"
                style={{ backgroundColor: "#f25286", borderStyle: "none" }}
              >
                Send
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
